import { render, staticRenderFns } from "./EditMessageCenterView.vue?vue&type=template&id=3ed9c2e7&scoped=true&"
import script from "./EditMessageCenterView.vue?vue&type=script&lang=js&"
export * from "./EditMessageCenterView.vue?vue&type=script&lang=js&"
import style0 from "./EditMessageCenterView.vue?vue&type=style&index=0&id=3ed9c2e7&lang=scss&scoped=true&"
import style1 from "./EditMessageCenterView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed9c2e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCard,VCardText,VCardTitle,VCol,VForm,VIcon,VRow,VSwitch,VTextField,VTextarea})
